import { MissionControlPlugin, PluginDefaultStatus, PluginPimsDependency } from '@v2/types';

/** Default status option for dropdown */
export type DefaultStatusOption = 'Running' | 'Installed' | 'Cached' | 'Present in Manifest';

export const DEFAULT_STATUS_OPTIONS: DefaultStatusOption[] = [
  'Running',
  'Installed',
  'Cached',
  'Present in Manifest',
];

export function defaultStatusToDiscrete(option: DefaultStatusOption | ''): PluginDefaultStatus {
  switch (option) {
  case '':
    return { isCached: false, isInstalled: false, isRunning: false };
    case 'Running':
      return { isCached: true, isInstalled: true, isRunning: true };
    case 'Installed':
      return { isCached: true, isInstalled: true, isRunning: false };
    case 'Cached':
      return { isCached: true, isInstalled: false, isRunning: false };
    case 'Present in Manifest':
    default:
      return { isCached: false, isInstalled: false, isRunning: false };
  }
}

export function discreteToDefaultStatusOption(
  status: PluginDefaultStatus
): DefaultStatusOption {
  if (status?.isRunning) return 'Running';
  if (status?.isInstalled) return 'Installed';
  if (status?.isCached) return 'Cached';
  return 'Present in Manifest';
}

export interface PluginFormProps {
  plugin?: MissionControlPlugin | null;
  /** When creating, used to validate plugin ID is not already in use. */
  existingPluginIds?: string[];
  onCancel: () => void;
  onCompleted: (pluginId?: string) => void;
}

/** Form field values (strings for inputs) */
export interface PluginFormData {
  pluginId: string;
  name: string;
  defaultVersionId: string;
  defaultStartupTimeout: string;
  /** On create, starts empty; user must select. On edit, set from plugin. */
  defaultStatus: DefaultStatusOption | '';
  isInactive: boolean;
  scheduledReleaseEnabled: boolean;
  scheduledReleaseTime: string;
  pimsDependencies: PluginPimsDependency[];
}
